
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import DrawerCard from '@/components/DrawerCard.vue'
import Icon from '@/components/Icon.vue'
import { namespace } from 'vuex-class'
import { MappableModel } from '@/interfaces/MappableModel'
import { GeoJSON } from 'geojson'
import SphereViewerDialog from '@/components/SphereViewerDialog.vue'
import ConfirmationDialog from '@/components/ConfirmationDialog.vue'
import { Panorama } from '@/models/Panorama'
import GeoDirection from '@/directions/types/GeoDirection'
import { distance } from '@turf/distance'
import PanoramaPreview from '@/components/PanoramaPreview.vue'

const Viewport = namespace('viewport')
const Auth = namespace('auth')

@Component({
	components: {
		PanoramaPreview,
		ConfirmationDialog,
		SphereViewerDialog,
		DrawerCard,
		Icon
	}
})
export default class FacilityInfo extends Vue {
	@Viewport.Getter('isMobile')
	isMobile!: boolean

	@Auth.Getter('requiredProfileFieldsComplete')
	requiredProfileFieldsComplete!: boolean

	@Prop({ default: null })
	directionsTo!: MappableModel | null

	@Prop({ default: null })
	vhf!: number | null

	@Prop({ default: false })
	isEditable!: boolean

	@Prop({ default: null })
	previewImage!: string | null

	openCard: boolean = false
	sphereViewerDialogOpened = false
	sphereViewerBearing = 0
	availablePanoramas: Array<Panorama> = []

	get nearestPanorama(): Panorama | null {
		if (!this.directionsTo) return null
		const facilityCoordinates = (this.directionsTo!.getLocation() as GeoJSON.Point).coordinates
		const sortedByDistance = this.availablePanoramas
			.filter((image) => image.is360Image)
			.sort((a, b) =>
				distance(facilityCoordinates, (a.position as GeoJSON.Point).coordinates) >
				distance(facilityCoordinates, (b.position as GeoJSON.Point).coordinates)
					? 1
					: -1
			)
		return sortedByDistance[0] ?? null
	}

	@Watch('directionsTo', { immediate: true })
	async onDirectionsToChanged() {
		if (this.directionsTo) {
			const location = this.directionsTo.getLocation() as GeoJSON.Point
			this.availablePanoramas = (
				await Panorama.where('position', GeoDirection.pointToString(location)).get()
			).getData() as Array<Panorama>
		}
	}
}
